import { Outlet } from 'react-router-dom'

export default function PlannerHome() {
  return (
    <Outlet/>
  )
}